import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ViewOriginModal = ({ isOpen, toggle, locations, routes = 'Origin' }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size='md'>
      <ModalHeader
        toggle={toggle}
        className='fw-semibold'
        style={{ borderBottom: '1px solid var(--vz-border-color, #e5e7eb)' }}
      >
        <i className='ri-map-pin-line me-2' style={{ color: '#0d7c66' }}></i>
        View {routes} Locations
      </ModalHeader>
      <ModalBody className='py-4'>
        {locations.length === 0 ? (
          <p
            className='text-muted text-center py-3 mb-0'
            style={{ fontSize: '13px' }}
          >
            No {routes.toLowerCase()} locations available
          </p>
        ) : (
          <div
            className='table-responsive'
            style={{ maxHeight: '407px', overflowY: 'auto' }}
          >
            <table
              className='align-middle table-nowrap mb-0'
              style={{ width: '100%' }}
            >
              <thead className='table-light'>
                <tr>
                  <th style={{ width: '50px' }}>No</th>
                  <th>Location Name</th>
                </tr>
              </thead>
              <tbody>
                {locations.map((loc, idx) => (
                  <tr
                    key={idx}
                    style={{
                      borderBottom: '1px solid var(--vz-border-color, #e5e7eb)',
                    }}
                  >
                    <td className='text-center'>{idx + 1}</td>
                    <td>{loc.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </ModalBody>
      <ModalFooter
        style={{ borderTop: '1px solid var(--vz-border-color, #e5e7eb)' }}
      >
        <Button color='secondary' size='sm' outline onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewOriginModal;
